import React from 'react';
import logo from '../../assets/logo.svg';
import styles from './style.less'

const UserLayout = ({ children }) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.top}>
                    <div className={styles.header}>
                        {/* <Link to="/"> */}
                            <img alt="logo" className={styles.logo} src={"https://anchong-dev-1304380937.cos.ap-shanghai.myqcloud.com/ea3f422ec7eb4e3d962c326a18a062falogo-lf.png"} />
                            <span className={styles.title}>安充招商OA系统</span>
                        {/* </Link> */}
                    </div>
                    {/* <div className={styles.desc}>打造全宇宙领先的一站式屏幕管理运行后台系统</div> */}
                </div>
                { children }
            </div>
            {/* <DefaultFooter /> */}
        </div>
    )
}

export default UserLayout
